import React from 'react';
import { solutions, solutionsContent } from '../data';
import { SolutionsProps } from '../types';
import SolutionsPresentation from './SolutionsPresentation';

const SolutionsContainer: React.FC<SolutionsProps> = ({ 
  className, 
  id = 'solutions' 
}) => {
  return (
    <SolutionsPresentation
      id={id}
      heading={solutionsContent.heading}
      description={solutionsContent.description}
      solutions={solutions}
    />
  );
};

export default SolutionsContainer;